module.exports = __webpack_public_path__ + "static/img/activity_sdy_04-4.a8f1707.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_04-4.jpg
// module id = 69Ur
// module chunks = 0